module.exports = __webpack_public_path__ + "static/img/Paris.4c734df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/destination/Paris.jpg
// module id = WOL2
// module chunks = 1